import { round } from '../../helpers/Format';
import CollaboratorStretch from '../CollaboratorStretches/CollaboratorStretch';
export const precioIva = (item) => {
    // console.log('item', item)
    if (item.stretchPrice.tax) {
        const tax = item.stretchPrice.tax.value;
        const factor = tax + 1;
        const result = item.stretchPrice.price * factor;
        return round(result);
    }
    return '';
};
export const priceWithTax = (value, taxValue, item) => {
    const factor = taxValue + 1;
    const result = value * factor;
    return round(result);
};
// retorna sale en función de si es vuelta y si ha seleccionado afiliado
export const getSale = (stretch, vuelta, affiliate) => {
    let prices = vuelta && stretch.vuelta && stretch.vueltaPrices
        ? stretch.vueltaPrices
        : stretch.prices;
    /*if (affiliate && affiliate.calcImport && stretch.afiliatePrices) {
      let filtered
  
      if (!vuelta) {
        filtered = stretch.afiliatePrices.filter(
          (price) => price.afiliate_id === affiliate?.id && !price.idaVuelta
        )
      } else {
        filtered = stretch.afiliatePrices.filter(
          (price) => price.afiliate_id === affiliate?.id && price.idaVuelta
        )
      }
  
      if (affiliate && filtered.length > 0) {
        prices = filtered.map((price) => {
          const passengerCategory = stretch.afiliatePassengerCategories.find(
            (passenger) => passenger.id === price.passengerCategory_id
          )
          const tempPrice: StretchPrice = {
            id: price.id,
            stretch_id: stretch.id,
            printPrice: true,
            order: passengerCategory.order,
            passengerCategory_id: price.passengerCategory_id,
            passengerCategory,
            price: price.priceNet,
            tax: stretch.tax,
            affiliate,
          }
          return tempPrice
        })
      }
    }*/
    /*if (affiliate && affiliate.commission) {
      prices = prices.map(price => {
        return {
          ...price,
          price: price.price - (price.price * affiliate.commission / 100)
        }
      })
    }*/
    let pricesFiltered = prices
        .filter((price) => !price.passengerCategory.disabled_at);
    if (stretch instanceof CollaboratorStretch) {
        pricesFiltered = pricesFiltered.filter(price => (!!price.price && price.price >= 0 && !!price.priceNet && price.priceNet >= 0));
    }
    return pricesFiltered
        .map((item) => {
        if (stretch.tax) {
            item.tax = stretch.tax;
        }
        return {
            order: item.passengerCategory.order,
            quantity: 0,
            stretchPrice: Object.assign(Object.assign({}, item), { printPrice: stretch.printPrice }),
        };
    })
        .sort((a, b) => {
        return a.order - b.order;
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Utils/Util.ts
// module id = 157
// module chunks = 0